import React, { useState, useEffect } from 'react';
import Tabs from '../components/Tabs';
import TimePicker from '../components/TimePicker';
import SalesCard from '../components/SalesCard';
import Colors from '../components/Colors';
import { Link, useNavigate } from 'react-router-dom';
import { pdfLink } from '../components/Strings';

const HomePage = () => {
  const [activeTab, setActiveTab] = useState('Today');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const navigate = useNavigate();

  // Dynamic sales data (all locations)
  const [salesData, setSalesData] = useState({});
  const [invoicesData, setInvoicesData] = useState({});

  const handleTabChange = (tab) => setActiveTab(tab);

  const handleTimeChange = (start, end) => {
    setStartTime(start);
    setEndTime(end);
  };

  const printInvoices = (location) => {
    const url = `${pdfLink}/generateSalesPdf.php?location=${location}&tab=${activeTab}&starttime=${startTime}&endtime=${endTime}`;
    window.open(url, '_blank');
  };

  const fetchSalesData = async () => {
    try {
      const response = await fetch('https://app.mirzawaleed.com/getInvoices.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          tab: activeTab,
          startTime,
          endTime,
        }),
      });

      const data = await response.json();

      // Store dynamic data directly
      setSalesData(data);

      // Extract invoices from backend
      const invoices = {};
      Object.keys(data).forEach((loc) => {
        invoices[loc] = data[loc]?.invoices || [];
      });

      setInvoicesData(invoices);

    } catch (error) {
      console.error('Error fetching sales data:', error);
    }
  };

  useEffect(() => {
    fetchSalesData();
  }, [activeTab, startTime, endTime]);

  return (
    <div style={{ padding: '20px' }}>
      <h1 style={{ textAlign: 'center' }}>Dashboard</h1>

      <Tabs activeTab={activeTab} onTabChange={handleTabChange} />

      {/* Print buttons dynamically */}
      <div style={{ 
        margin: '20px 0',
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        gap: '6px'
      }}>
        {Object.keys(salesData).map((loc) => (
          <button
            key={loc}
            onClick={() => printInvoices(loc)}
            style={{
              margin: '4px',
              backgroundColor: Colors.primary,
              color: 'white',
              cursor: 'pointer',
              borderRadius: '4px',
              padding: '12px',
            }}
          >
            Load Sheet For {loc}
          </button>
        ))}
      </div>

      <TimePicker onTimeChange={handleTimeChange} startTime={startTime} endTime={endTime} />

      {/* Responsive cards */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '20px',
          marginTop: '20px',
        }}
      >
        {Object.keys(salesData).map((loc) => (
          <SalesCard
            key={loc}
            location={loc}
            data={salesData[loc]}
            invoices={invoicesData[loc] || []}
            starttime={startTime}
            endtime={endTime}
            tab={activeTab}
          />
        ))}
      </div>

      {/* Floating Add Button */}
      <div
        style={{
          position: 'fixed',
          bottom: '100px',
          right: '20px',
          width: '80px',
          height: '80px',
          background: Colors.primary,
          borderRadius: '50px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          color: 'white',
          textAlign: 'center',
          fontSize: '38px',
          cursor: 'pointer',
        }}
        onClick={() => navigate('/createinvoice')}
      >
        <span style={{ marginBottom: '10px' }}>+</span>
      </div>
    </div>
  );
};

export default HomePage;
